import { useState } from 'react'
import { Button, DateField, Drawer, SelectField, TextField } from '@shared/design-system/ui'
import { toast } from '@shared/lib/toast/toast-store'
import { useCreateCourtesy } from '../model/members-access.mutations'
import { drawerStack } from './members-area.css'

export function CourtesyDrawer({
  open,
  products,
  onClose,
}: {
  open: boolean
  products: ReadonlyArray<{ productId: string; name: string }>
  onClose: () => void
}) {
  const create = useCreateCourtesy()
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [productId, setProductId] = useState(products[0]?.productId ?? '')
  const [accessUntil, setAccessUntil] = useState('')
  const selectedProductId = productId || products[0]?.productId || ''

  function reset() {
    setName('')
    setEmail('')
    setProductId(products[0]?.productId ?? '')
    setAccessUntil('')
  }

  async function submit() {
    try {
      await create.mutateAsync({
        name: name.trim(),
        email: email.trim(),
        productId: selectedProductId,
        ...(accessUntil ? { accessUntil: `${accessUntil}T23:59:59.000Z` } : {}),
      })
      toast.success({ title: 'Cortesia adicionada' })
      reset()
      onClose()
    } catch {
      toast.error({ title: 'Não foi possível adicionar a cortesia' })
    }
  }

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title="Adicionar cortesia"
      description="Libera o conteúdo de um produto sem uma venda."
      size="standard"
      variant="form"
      busy={create.isPending}
      footer={
        <>
          <Button variant="secondary" disabled={create.isPending} onClick={onClose}>
            Cancelar
          </Button>
          <Button
            disabled={!name.trim() || !email.trim() || !selectedProductId || create.isPending}
            onClick={() => void submit()}
          >
            Adicionar cortesia
          </Button>
        </>
      }
    >
      <div className={drawerStack}>
        <TextField label="Nome" value={name} onChange={(event) => setName(event.target.value)} />
        <TextField
          label="E-mail"
          type="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />
        <SelectField
          label="Produto"
          value={selectedProductId}
          onChange={(event) => setProductId(event.target.value)}
          options={products.map((product) => ({ value: product.productId, label: product.name }))}
        />
        <DateField
          label="Validade (opcional)"
          value={accessUntil}
          onChange={(event) => setAccessUntil(event.target.value)}
        />
      </div>
    </Drawer>
  )
}
